module.exports = __webpack_public_path__ + "static/media/default.b68f7ddf.jpg";